<template>
	<div class="list">
		<div class="item flex-column" v-for="item in list">
			<div class="top flex-column">
				<div class="name">
					{{ item.comment }}
				</div>
				<!-- <div class="imgs flex_wrap">
					<div class="imgs-item" v-for="item in 4"></div>
				</div> -->
				<div class="time">{{ item.create_time }}</div>
			</div>
			<div class="btm">
				平台回复：<span>{{ item.dispose_remark || '未回复' }}</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: []
			};
		},
		created() {
			this.init()
		},
		methods: {
			init() {
        this.$api
          .request('Member/comments').then((res) => {
             // console.log('res:', res)
             this.list = res.data
          })
			}
		}
	}
</script>

<style scoped>
  body {
  	background-color: #f2f2f2;
  }
</style>
<style lang="less">
	.list {
		padding: 15px;
    text-align: left;

		.item {
			background: #fff;
			padding: 0 15px;
			border-radius: 10px;
			margin-bottom: 12.5px;

			.btm {
				font-size: 14px;
				color: #000;
				border-top: 1px solid #f2f2f2;
				line-height: 22.5px;

				span {
					color: #999;
				}
			}

			.top {
				padding: 15px 0;
				.name {
					font-size: 14px;
					color: #000;
					line-height: 22.5px;
				}
				.imgs {
					margin-top: 12.5px;
					.imgs-item {
						width: calc((100% - (7.5px * 2)) / 3);
						aspect-ratio: 1/1;
						background: #f2f2f2;
						margin-right: 7.5px;
						margin-top: 7.5px;
						&:nth-child(3n) {
							margin-right: 0;
						}
						&:nth-child(-n+3) {
							margin-top: 0;
						}
						image {
							width: 100%;
							height: 100%;
							object-fit: cover;
						}
					}
				}
				.time {
					font-size: 14px;
					color: #999;
					text-align: right;
					margin-top: 15px;
				}
			}

			.btm {
				padding: 12.5px 0;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/complaintRecords.vue